// extracted by css-extract-rspack-plugin
export default {"calendar":"calendar__calendar___SwTK6","calbounce":"calendar__calbounce___otelo","eyebounce":"calendar__eyebounce___mco2T"};